import { Gray100, Gray200 } from '@zep-us/zus/tokens';
import { cn } from '@/utils/tailwind.util';
const FOLDER_GEOMETRY = {
  card: {
    width: 137,
    height: 98,
    outline: 'M53 0C58.9221 1.07942e-07 64.0919 3.21785 66.8584 8H121C129.837 8 137 15.1634 137 24V82C137 90.8366 129.837 98 121 98H16C7.30155 98 0.223981 91.0587 0.00488281 82.4131C0.00140413 82.2758 0 82.1381 0 82V16C0 7.16344 7.16344 1.61064e-07 16 0H53Z'
  },
  hero: {
    width: 180,
    height: 130,
    outline: 'M74 0C81.4554 0 87.7199 5.09907 89.4961 12H164C172.837 12 180 19.1634 180 28V114C180 122.837 172.837 130 164 130H16C7.16344 130 0 122.837 0 114V16C0 7.16344 7.16344 0 16 0H74Z'
  },
  /** 저장 모달 목록 행 (70×50). */
  row: {
    width: 70,
    height: 50,
    outline: 'M27 0C29.9606 0 32.5433 1.60951 33.9268 4H62C66.4183 4 70 7.58172 70 12V42C70 46.4183 66.4183 50 62 50H8C3.58172 50 0 46.4183 0 42V8C0 3.58172 3.58172 0 8 0H27Z'
  },
  heroMobile: {
    width: 120,
    height: 85,
    outline: 'M52 0C55.7277 0 58.86 2.54954 59.748 6H112C116.418 6 120 9.58172 120 14V77C120 81.4183 116.418 85 112 85H8C3.58172 85 0 81.4183 0 77V8C0 3.58172 3.58172 0 8 0H52Z'
  }
} as const;
export type FolderShapeSize = keyof typeof FOLDER_GEOMETRY;
const STROKE_INSET = 0.5;
const STROKE_TRANSFORM: Record<FolderShapeSize, string> = {
  card: buildStrokeTransform('card'),
  hero: buildStrokeTransform('hero'),
  heroMobile: buildStrokeTransform('heroMobile'),
  row: buildStrokeTransform('row')
};
function buildStrokeTransform(size: FolderShapeSize) {
  const {
    width,
    height
  } = FOLDER_GEOMETRY[size];
  return `translate(${STROKE_INSET} ${STROKE_INSET}) scale(${(width - STROKE_INSET * 2) / width} ${(height - STROKE_INSET * 2) / height})`;
}
export const FOLDER_BOX = 'h-[98px] w-[137px] max-tablet-lg:h-[59px] max-tablet-lg:w-[80px]';
export const FOLDER_BOX_HERO = 'h-[130px] w-[180px]';
export const FOLDER_BOX_HERO_MOBILE = 'h-[85px] w-[120px]';

/** 저장 모달의 목록 행 (70×50). */
export const FOLDER_BOX_ROW = 'h-[50px] w-[70px]';
export type FolderShapeVariant = 'create' | 'filled';
const FOLDER_FILL: Record<FolderShapeVariant, string> = {
  create: '#F9FAFB',
  filled: Gray100
};
interface FolderShapeProps {
  variant: FolderShapeVariant;
  size?: FolderShapeSize;
  /** 바탕색(CSS 색). 없으면 `variant` 의 기본색이다 — 폴더 색은 `FolderThumbnail` 이 넘긴다. */
  fill?: string;
  className?: string;
}
export const FolderShape = ({
  variant,
  size = 'card',
  fill,
  className
}: FolderShapeProps) => {
  const {
    width,
    height,
    outline
  } = FOLDER_GEOMETRY[size];
  return <svg aria-hidden focusable={'false'} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio={'none'} className={cn('absolute inset-0 size-full', className)} data-sentry-element="svg" data-sentry-component="FolderShape" data-sentry-source-file="FolderShape.tsx">
      <path d={outline} fill={fill ?? FOLDER_FILL[variant]} data-sentry-element="path" data-sentry-source-file="FolderShape.tsx" />
      <g transform={STROKE_TRANSFORM[size]} data-sentry-element="g" data-sentry-source-file="FolderShape.tsx">
        <path d={outline} fill={'none'} stroke={Gray200} strokeWidth={1} data-sentry-element="path" data-sentry-source-file="FolderShape.tsx" />
      </g>
    </svg>;
};